import { Link } from "react-router-dom"
import { motion } from "framer-motion"

import Seo from "@/components/seo/Seo"

export default function NotFound() {
  return (
    <>
      <Seo
        title="404 | Page Not Found"
        description="The page you are looking for could not be found."
        canonical="https://zeniastays.com/404"
        noIndex
      />

      <main className="relative flex min-h-[100svh] items-center justify-center overflow-hidden bg-gradient-soft px-containerX text-text-primary">

        <div className="absolute inset-0 overflow-hidden">

          <motion.div
            animate={{
              scale: [1, 1.08, 1],
              opacity: [0.08, 0.16, 0.08],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute left-1/2 top-1/2 h-[42rem] w-[42rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-light blur-3xl"
          />

          <motion.div
            animate={{
              y: [0, -16, 0],
            }}
            transition={{
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute left-[12%] top-[18%] h-32 w-32 rounded-full border border-border-soft bg-bg-surface/40 backdrop-blur-md"
          />

          <motion.div
            animate={{
              y: [0, 20, 0],
            }}
            transition={{
              duration: 7,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="absolute bottom-[16%] right-[10%] h-44 w-44 rounded-full border border-border-soft bg-bg-surface/40 backdrop-blur-md"
          />

        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.55,
            ease: "easeOut",
          }}
          className="relative z-10 mx-auto flex w-full max-w-content flex-col items-center text-center"
        >

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              delay: 0.05,
              duration: 0.4,
            }}
            className="mb-5 text-micro font-medium uppercase tracking-[0.28em] text-text-muted"
          >
            Error 404
          </motion.p>

          <motion.div
            animate={{
              y: [0, -6, 0],
            }}
            transition={{
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          >
            <h1 className="bg-gradient-brand bg-clip-text font-heading text-[6.5rem] font-black leading-[0.9] tracking-[-0.08em] text-transparent sm:text-[8rem] md:text-[10rem]">
              404
            </h1>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.12,
              duration: 0.45,
            }}
            className="mt-6 max-w-reading font-heading text-section font-semibold tracking-tight text-text-primary md:text-title"
          >
            This stay does not exist
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.18,
              duration: 0.45,
            }}
            className="mt-5 max-w-reading text-body text-text-subtle"
          >
            The page you are trying to access may have been removed,
            renamed, or is temporarily unavailable.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.24,
              duration: 0.45,
            }}
            className="mt-10"
          >
            <Link
              to="/"
              className="btn-primary inline-flex items-center justify-center rounded-pill px-7 py-3"
            >
              Return Home
            </Link>
          </motion.div>

        </motion.div>

      </main>
    </>
  )
}